import React, { useEffect } from 'react';
// import { socket } from './socket';
import is from 'is_js';
import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Chart as ChartJS, registerables } from 'chart.js';
import { CloseButton } from 'components/common/Toast';
import SettingsToggle from 'components/settings-panel/SettingsToggle';
import SettingsPanel from 'components/settings-panel/SettingsPanel';
import { useAppContext } from 'providers/AppProvider';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import InactivityHandler from 'InactivityHandler';
import { UnsavedChangesProvider } from 'components/prescription/UnsavedChangesContext';
import { initAnalytics, initButtonTracking } from 'helpers/gtm';
import usePageTracking from 'helpers/usePageTracking';

ChartJS.register(...registerables);

const App = () => {
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  const {
    config: { navbarPosition }
  } = useAppContext();

  // GA4: report a page_view on every route change.
  usePageTracking();

  // GA4: load gtag (prod only) + bind the delegated click tracker once on mount.
  useEffect(() => {
    initAnalytics();
    initButtonTracking();
  }, []);

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add('windows');
    }
    if (is.chrome()) {
      HTMLClassList.add('chrome');
    }
    if (is.firefox()) {
      HTMLClassList.add('firefox');
    }
    if (is.safari()) {
      HTMLClassList.add('safari');
    }
  }, [HTMLClassList]);

  useEffect(() => {
    if (navbarPosition === 'double-top') {
      HTMLClassList.add('double-top-nav-layout');
    }
    return () => HTMLClassList.remove('double-top-nav-layout');
  }, [navbarPosition]);




  return (
    <InactivityHandler>
      <UnsavedChangesProvider>
        <>
          <Outlet />
          {/*<SettingsToggle />
      <SettingsPanel />*/}
          <ToastContainer
            closeButton={CloseButton}
            icon={false}
            position="bottom-left"
          />
        </>
      </UnsavedChangesProvider>
    </InactivityHandler>
  );
};

export default App;
